import { render, staticRenderFns } from "./HoldingSharesTable.vue?vue&type=template&id=4cc10898&"
import script from "./HoldingSharesTable.vue?vue&type=script&lang=js&"
export * from "./HoldingSharesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports